(function() {
    let timer = null;
    let pid = null;
    let product = null;
    change_price();

    /************************************分割线*************************************/

    function change_price() {
        let n = 0;
        timer = setInterval(function() {
            if (++n > 500) {
                clearInterval(timer);
            }
            if (product) {
                // console.log('---',product)
                change_product_price();
                change_variant_price();
                change_bundle_product_price();
                change_bundle_variant_price();
                add_count_down_box(product.end_time);

                // Don't clear the interval timer
            } else {
                const pid_obj = $('.hdt-main-area .review-widget ryviu-widget-total');
                if (pid_obj.length > 0) {
                    pid = $.trim(pid_obj.attr('product_id'));
                    product = get_the_right_activity_products(pid) || get_the_right_daily_products(pid) || get_the_right_weekly_products(pid);
                }
            }
        }, 30);
    }

    function change_product_price() {   
        let money_obj = $('.hdt-product__price .hdt-price-wrapp .money');
        if (!money_obj.eq(0).text() || money_obj.eq(0).attr('changed') === '1') {
            return ;
        }

        show_price()
    }

    function change_variant_price() {
        let variant_items = $('.hdt-product-form__values .hdt-product-form_value');
        if ((variant_items).length <= 0 || variant_items.hasClass('has-bound')) {
            return ;
        }

        //console.log('variant_price', variant_items);
        variant_items.addClass('has-bound');
        variant_items.on('click', function() {
            clearInterval(timer);

            const index = $(this).index();
            const variant_index = index - Math.ceil(index/2);
            show_price(variant_index);

            const form_obj = $('fbt-form-template--16908469076137__main-');
            const bundle_variant_select = form_obj.find('.hdt-fbt__swatches .hdt-product-fbt__item:eq(0) select');
            bundle_variant_select.find('option').eq($(this).index()).prop('selected', true);
            bundle_variant_select.change();
        });
    }
    
    function change_bundle_product_price() {
        if (product.type == 'tomorrow-preview') {
            return ;
        }
        const form_obj = $('#fbt-form-template--16908469076137__main-');
        if (form_obj.length <= 0) {
            return ;
        }

        const total_price_obj = form_obj.find('.hdt-product__fbt-total .hdt-compare-at-price');
        if (total_price_obj.find('.money').attr('changed') === 1) {
            return ;
        }

        show_bundle_price();
    }

    function change_bundle_variant_price() {
        if (product.type == 'tomorrow-preview') {
            return ;
        }
        const form_obj = $('#fbt-form-template--16908469076137__main-');
        const variant_select = form_obj.find('.hdt-fbt__swatches .hdt-product-fbt__item:eq(0) select');
        if (variant_select.length <= 0 || variant_select.hasClass('has-bound')) {
            return ;
        }

        variant_select.addClass('has-bound')
        variant_select.change(function() {
            clearInterval(timer);
            let variant_index = variant_select.find('option:selected').index();
            show_bundle_price(variant_index);
        });
    }

    function add_count_down_box(end_time) {
        if (!end_time || $('.count-down-box').length > 0) {
            return ;
        }
        
        let rand_id = "count-down-" +  Math.ceil(Math.random() * 10000);
        let notice_str = "Ends In";
        if (product.type == 'tomorrow-preview') {
            notice_str = "Starts In";
        }
        // const html = `
        // <div class='count-down-box' id='${rand_id}' style='display:none;'>
        //     <span class='count-end-in'>${notice_str} </span>
        //     <div class='count-down-item count-down-day'>
        //         <span class='day-num num-span'>00</span>
        //         <span class='desc-span'>d</span>
        //     </div>
        //     <div class='count-down-item count-down-hour'>
        //         <span class='hour-num num-span'>00</span>
        //         <span class='desc-span'>h</span>
        //     </div>
        //     <div class='count-down-item count-down-minute'>
        //         <span class='minute-num num-span'>00</span>
        //         <span class='desc-span'>m</span>
        //     </div>
        //     <div class='count-down-item count-down-second'>
        //         <span class='second-num num-span'>00</span>
        //         <span class='desc-span'>s</span>
        //     </div>
        // </div>`;

        const html = `
        <div class='count-down-box' id='${rand_id}' style='display:none;'>
            <div class="count-desc">FLASH SALE</div>
            <div class="count-time-box">
                <span class='count-end-in'>${notice_str} </span>
                <div class='count-down-item count-down-day'>
                  <span class='day-num num-span'>00</span>
                  <span>d</span>
                </div>
                <div class='count-down-item count-down-hour'>
                    <span class='hour-num num-span'>00</span>
                    <span>:&nbsp;</span>
                </div>
                <div class='count-down-item count-down-minute'>
                    <span class='minute-num num-span'>00</span>
                    <span>:&nbsp;</span>
                </div>
                <div class='count-down-item count-down-second'>
                    <span class='second-num num-span'>00</span>
                </div>
            </div>
        </div>`;
      
        $('#product-info-template--16990066147497__main .hdt-product__price').after(html);
        
        let count_down_box = $("#" + rand_id);
    
        count_down_run(count_down_box, end_time);
        count_down_box.show();
        timer_for_count_down = setInterval(function() {
            count_down_run(count_down_box, end_time);
        }, 1000);
    };

    function show_price(variant_index = 0) {
      console.log(product.variant_price[variant_index]);
        const compare_price = product.variant_price[variant_index][0].toFixed(2);
        const real_price = product.variant_price[variant_index][1].toFixed(2);
        let html = create_price_html(compare_price, real_price);
        if (compare_price - real_price > 0) {
            const  discount = Math.round((compare_price - real_price) / compare_price * 100);
            html += "<span class='hdt-badge-price'>SAVE " + discount +"%</span>";
        }
    
        setTimeout(function() {
            $('.hdt-product__price .hdt-price-wrapp').html(html);
        }, 25)
    }
    
    function show_bundle_price(variant_index = 0) {
        const form_obj = $('#fbt-form-template--16908469076137__main-');
        const total_price_obj = form_obj.find('.hdt-product__fbt-total .hdt-compare-at-price');
        const product_list = form_obj.find('.hdt-fbt__swatches .hdt-product-fbt__item'); 
        const product_price_first = product_list.eq(0).find('.hdt-product__fbt-price');

        const compare_price = product.variant_price[variant_index][0].toFixed(2);
        const real_price = product.variant_price[variant_index][1].toFixed(2);
        let html = create_price_html(compare_price, real_price)

        let total_price = 0;
        product_list.slice(1).each(function() {
            let this_price = $(this).find('.hdt-product__fbt-price .money').text().substr(1);
            total_price -= -this_price;
        });

        let total_compare_price = (total_price - -compare_price).toFixed(2);
        let total_real_price = (total_price - -real_price).toFixed(2);
        let total_price_html = create_price_html(total_compare_price, total_real_price);
        
        setTimeout(function() {
            product_price_first.empty().html(html);
            total_price_obj.empty().html(total_price_html);
        }, 25);

    }

    function get_the_right_activity_products(pid) {
        if (!activity_products?.show) {
                return null;
        }
        let pname = get_product_name_by_id(pid);
        if (!pname) {
            return null;
        }
    
        let variant_price = [];
        for (let i in activity_products.list) {
            if (i == pname) {
                variant_price = activity_products.list[i].variant_price;
            }
        }
        if (variant_price.length == 0) {
            return null;
        }

        const now = set_now_time();
        let { start_time, end_time } = activity_products;
        if (start_time) {
            const start_timestamp = convert_datetime_to_timestamp(start_time);
            if (now < start_timestamp) {
                return null;
            }
        }
        let end_timestamp = 0;
        if (end_time) {
            end_timestamp = convert_datetime_to_timestamp(end_time);
            if (now > end_timestamp) {
                return null;
            }
        }

        return {
            'variant_price': variant_price,
            "type": "activity",
            'end_time': activity_products.show_count_down_box ? end_timestamp : 0
        };
    }
    
    function get_the_right_daily_products(pid) {
        if (!daily_deal_products?.show) {
            return null;
        }
    
        let pname = get_product_name_by_id(pid);
        if (!pname) {
            return null;
        }
    
        let now = set_now_time();
        let this_round = null;
        let next_round = null;
        const { list, start_time } = daily_deal_products;
        for (let i in list) {
            if (list[i].product == pname) {
                const start_time_str = `${this_year}-${i} ${start_time}`;
                let start_timestamp = convert_datetime_to_timestamp(start_time_str);
                let end_timestamp = start_timestamp + 12 * 3600;
                if (now > start_timestamp && now < end_timestamp) {
                    this_round = {
                        'variant_price': list[i].variant_price,
                        "end_time": end_timestamp,
                        'type': 'daily'
                    };
                    break ;
                } else if (now < start_timestamp && now > start_timestamp - 12 * 3600) {
                    next_round = {
                        'variant_price': list[i].variant_price,
                        "end_time": start_timestamp,
                        'type': 'tomorrow-preview'
                    };
                }
            }
        }
    
        return this_round ? this_round : next_round;
    }
    
    function get_the_right_weekly_products(pid) {
        if (!weekly_deal_products?.show) {
                return null;
        }
        
        const now = set_now_time();
        const { list, start_time } = weekly_deal_products;
        for (let i in list) {
            const start_time_str = `${this_year}-${i} ${start_time}`;
            const start_timestamp = convert_datetime_to_timestamp(start_time_str);
            const end_timestamp = start_timestamp + 7 * 24 * 3600;
            let item = list[i];
            if (now < end_timestamp && now > start_timestamp && item.product in product_common_info) {
                if (product_common_info[item.product]['id'] == pid) {
                    return {
                        'variant_price': item['variant_price'],
                        'end_time': end_timestamp,
                        'type': 'weekly'
                    };
                }
            }
        }
    
        return null;
    }
    
    function get_product_name_by_id(pid) {
        for (let i in product_common_info) {
            if (product_common_info[i]['id'] == pid) {
                return i;
            }
        }
    
        return null;
    }

    function create_price_html(compare_price, real_price) {
        let html = "<del style='font-size: 28px;'><span changed='1' class='money'>$"+compare_price+"</span></del>";
        html += "<span class='money' changed='1' style='color:#ec0101;font-size: 28px'>$"+real_price+"</span></ins>";

        return html;
    }
    
    function count_down_run(box, end_timestamp) {
        let now_timestamp = set_now_time();
        let rest_timestamp = end_timestamp - now_timestamp;
    
        if (rest_timestamp < 0) {
            clearInterval(timer_for_count_down);
            timer_for_count_down = null;
            location.reload();
            return ;
        }
    
        function pad_zero(num) {
          return num < 10 ? ("0" + num) : num;
        }
    
        let day = pad_zero(Math.floor(rest_timestamp / 86400));
        let hour = pad_zero(Math.floor((rest_timestamp % 86400) / 3600));
        let minute = pad_zero(Math.floor((rest_timestamp % 3600) / 60));
        let second = pad_zero(rest_timestamp % 60);
    
        if (day > 0) {
            box.find('.day-num').text(day);
        } else {
            box.find('.count-down-day').remove();
        }
        box.find('.hour-num').text(hour);
        box.find('.minute-num').text(minute);
        box.find('.second-num').text(second);
  };
})();